import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'competenciaToDate'
})
export class CompetenciaToDatePipe implements PipeTransform {

  transform(value: number): Date {
    const temp =
      (isNaN(value))
        ? null
        : new Date(value / 100, -1 + (value % 100));
    return temp;
  }

}
